/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_New_York_NyInputs */

const en_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. New York, NY`)
};

const es_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Madrid, España`)
};

const fr_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Paris, FR`)
};

const de_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Berlin, Deutschland`)
};

const ja_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 東京都渋谷区`)
};

const zh_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：北京，中国`)
};

const ar_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: دبي، الإمارات`)
};

const id_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Jakarta, ID`)
};

const it_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Milano, Italia`)
};

const ru_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, Москва`)
};

const pt_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. São Paulo, SP`)
};

const ko_eg_new_york_ny = /** @type {(inputs: Eg_New_York_NyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 서울특별시 강남구`)
};

/**
* | output |
* | --- |
* | "e.g. New York, NY" |
*
* @param {Eg_New_York_NyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_new_york_ny = /** @type {((inputs?: Eg_New_York_NyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_New_York_NyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_new_york_ny(inputs)
	if (locale === "es") return es_eg_new_york_ny(inputs)
	if (locale === "fr") return fr_eg_new_york_ny(inputs)
	if (locale === "de") return de_eg_new_york_ny(inputs)
	if (locale === "ja") return ja_eg_new_york_ny(inputs)
	if (locale === "zh") return zh_eg_new_york_ny(inputs)
	if (locale === "ar") return ar_eg_new_york_ny(inputs)
	if (locale === "id") return id_eg_new_york_ny(inputs)
	if (locale === "it") return it_eg_new_york_ny(inputs)
	if (locale === "ru") return ru_eg_new_york_ny(inputs)
	if (locale === "pt") return pt_eg_new_york_ny(inputs)
	return ko_eg_new_york_ny(inputs)
});